export const UPDATE_BRANCHES_LIST = "UPDATE_BRANCHES_LIST";
export const SET_BRANCHES_LIST = "SET_BRANCHES_LIST";
